import GoTrue from 'gotrue-js';
import { useQuery } from '@tanstack/react-query';
import { v4 as uuid } from 'uuid';
import { z } from 'zod';
import { graphql, useStaticQuery } from 'gatsby';

export const enrichResponseSchema = z
  .object({
    first_name: z.string(),
    last_name: z.string(),
    email: z.string().email().or(z.literal('')),
    phone: z.string(),
    company: z.string(),
    country: z.string(),
  })
  .strict();

export type EnrichResponseType = z.infer<typeof enrichResponseSchema>;

const useGetEnrichedInfo = (email?: string) => {
  const { site } = useStaticQuery<Queries.EnrichedInfoQuery>(graphql`
    query EnrichedInfo {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `);
  return useQuery({
    queryKey: ['enriched-info', email],
    enabled: email !== undefined,
    queryFn: async () => {
      const identifier = `${uuid()}@dummyaddress.com`;
      const auth = new GoTrue({
        APIUrl: `${site!.siteMetadata!.siteUrl}/.netlify/identity`,
        setCookie: false,
      });

      await auth.signup(identifier, identifier);
      const {
        token: { access_token },
      } = await auth.login(identifier, identifier);

      const enrichResponse = await fetch(
        `/api/enrich?${new URLSearchParams({ emailAddress: email! })}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );

      const body = await enrichResponse.json();
      return enrichResponseSchema.parse(body);
    },
  });
};

export default useGetEnrichedInfo;
